/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.utilsModule')

/**
 * Directive to include the value of the directive as a complied template.
 */
.directive('bulbIncludeTemplate', ['$compile', bulbIncludeTemplate]);

function bulbIncludeTemplate($compile) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var template = attrs.bulbIncludeTemplate;
      element.html(template);
      $compile(element.contents())(scope);
    }
  };
}
